import React from 'react';
import Navbar from '../Components/Navbar';
import HeroSection from '../Components/HeroSection';
import Footer from '../Components/Footer';

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />
      <HeroSection />
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-10">Privacy Policy & Terms</h1>

        {/* Privacy Policy Section */}
        <div className="bg-white shadow-md rounded-lg p-8 mb-8">
          <h2 className="text-3xl font-semibold text-gray-700 mb-6">Birimo Insurance Agency LLC Privacy Policy</h2>
          <p className="text-sm text-gray-600 mb-6"><strong>Effective Date:</strong> 9/18/2025</p>
          
          <p className="text-md text-gray-600 mb-6">
            Birimo Insurance Agency LLC ("we," "our," or "us") values your privacy. This Privacy Policy explains how we collect, use, and protect your personal information.
          </p>

          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold text-gray-700 mb-3">1. Information We Collect</h3>
              <ul className="list-disc pl-6 text-md text-gray-600 space-y-1">
                <li>Contact details (name, phone number, email, address).</li>
                <li>Insurance-related information (policy details, claims information, quotes).</li>
                <li>Payment and billing information (if applicable).</li>
                <li>Communication preferences, including SMS consent.</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-700 mb-3">2. How We Use Your Information</h3>
              <ul className="list-disc pl-6 text-md text-gray-600 space-y-1">
                <li>To provide insurance quotes, policies, and services.</li>
                <li>To send updates, reminders, and important notifications.</li>
                <li>To communicate via SMS, email, or phone (with your consent).</li>
                <li>To comply with legal and regulatory obligations.</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-700 mb-3">3. Sharing of Information</h3>
              <p className="text-md text-gray-600 mb-3">We do not sell your personal information. We may share information with:</p>
              <ul className="list-disc pl-6 text-md text-gray-600 space-y-1">
                <li>Insurance carriers and partners for policy and claims processing.</li>
                <li>Service providers who assist us in business operations.</li>
                <li>Legal or regulatory authorities when required by law.</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-700 mb-3">4.Mobile Messaging & SMS Privacy Policy</h3>
              <p className="text-md text-gray-600">
                Mobile opt-in data and consent information, including your phone number, will not be shared, sold, rented, or transferred to any third party or affiliate for their own marketing or promotional purposes.
  Information collected through mobile opt-in is used solely to deliver the communications you have consented to receive from us.</p>
            </div>
  
  <div>
              <h3 className="text-xl font-semibold text-gray-700 mb-3">5.Verbal Opt-In  </h3>
              <p className="text-md text-gray-600">
                By providing your phone number, you consent to receive text messages and calls from Birimo Insurance Agency LLC regarding customer service and your insurance. Message and data rates may apply. 
  You may opt out at any time by replying STOP. 
  Our privacy policy is available at https://birimoinsurance.com/privacy-policy — it explains how we collect, use, and protect your information. Would you like to proceed?
              </p>
            </div>
                
<div>
              <h3 className="text-xl font-semibold text-gray-700 mb-3">6.Verbal Opt-In  </h3>
              <p className="text-md text-gray-600">
                By providing your phone number, you agree to receive automated marketing messages and updates from Birimo Insurance Agency LLC at the number provided. Message and data rates may apply. Message frequency varies.
  To opt out at any time, reply STOP. For help, reply HELP. To review our Privacy Policy, visit birimoinsurance.com/privacy-policy or call us at 763-227-8620. Consent is not a condition of purchase </p>
            </div>
                
            <div>
              <h3 className="text-xl font-semibold text-gray-700 mb-3">7. Security</h3>
              <p className="text-md text-gray-600">
                We use reasonable safeguards to protect your information. However, no system is 100% secure, and we cannot guarantee absolute security.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-700 mb-3">8. Your Rights</h3>
              <p className="text-md text-gray-600">
                You may request to update, access, or delete your personal information by contacting us at:
                <br />
                <strong>Email:</strong> info@birimoinsurance.com | <strong>Phone:</strong> 763-227-8620
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-700 mb-3">9. Updates to This Policy</h3>
              <p className="text-md text-gray-600">
                We may update this Privacy Policy at any time. The latest version will always be available at Birimoinsurance.com.
              </p>
            </div>
          </div>
        </div>

        {/* Terms & Conditions Section */}
        <div className="bg-white shadow-md rounded-lg p-8">
          <h2 className="text-3xl font-semibold text-gray-700 mb-6">Terms & Conditions</h2>
          <p className="text-sm text-gray-600 mb-6"><strong>Effective Date:</strong> 9/18/2025</p>
          
          <p className="text-md text-gray-600 mb-6">
            These Terms & Conditions ("Terms") govern your use of services provided by Birimo Insurance Agency LLC. By engaging with us, you agree to these Terms.
          </p>

          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold text-gray-700 mb-3">1. Services</h3>
              <p className="text-md text-gray-600">
                We provide insurance quotes, policy support, and related customer service.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-700 mb-3">2. Communications Consent</h3>
              <p className="text-md text-gray-600 mb-3">
                By providing your contact information, you agree to receive communications from us, including SMS, calls, and emails.
              </p>
              <ul className="list-disc pl-6 text-md text-gray-600 space-y-1">
                <li>Message frequency varies.</li>
                <li>Standard message and data rates may apply.</li>
                <li>Reply STOP to opt-out at any time.</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-700 mb-3">3. No Guarantee of Coverage</h3>
              <p className="text-md text-gray-600">
                Submitting a request for a quote does not guarantee coverage. Insurance policies are subject to underwriting approval by the insurance carrier.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-700 mb-3">4. Limitation of Liability</h3>
              <p className="text-md text-gray-600">
                We are not liable for indirect, incidental, or consequential damages resulting from use of our services.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-700 mb-3">5. Governing Law</h3>
              <p className="text-md text-gray-600">
                These Terms are governed by the laws of the State of Minnesota.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-700 mb-3">6. Contact Us</h3>
              <div className="text-md text-gray-600">
                <p><strong>Birimo Insurance Agency LLC</strong></p>
                <p><strong>Address:</strong> PO BOX 8180, Minneapolis, MN 55408</p>
                <p><strong>Email:</strong> info@birimoinsurance.com</p>
                <p><strong>Phone:</strong> 763-227-8620</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
